function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import TabsFilter from '~/components/Molecules/TabsFilter.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTabsWithBannerGraphql',
  props: {
    background: null,
    title: null,
    text: null,
    linkText: null,
    tabsCollection: null,
    recipeCategoryPage: null,
    isAdviceBlock: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var ProductsCarouselGraphql = function ProductsCarouselGraphql() {
      return import('./ProductsCarouselGraphql.vue');
    };
    var ProductsGridGraphql = function ProductsGridGraphql() {
      return import('./ProductsGridGraphql.vue');
    };
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $config = _useNuxt2App.$config;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var currentTabIndex = ref(0);
    var cardsType = computed(function () {
      return props.isAdviceBlock ? 'adviceCardsCollection' : 'recipeCardsCollection';
    });
    var tabs = computed(function () {
      var _props$tabsCollection;
      return ((_props$tabsCollection = props.tabsCollection) === null || _props$tabsCollection === void 0 ? void 0 : _props$tabsCollection.items) || [];
    });
    var currentTab = computed(function () {
      return tabs.value[currentTabIndex.value];
    });
    var currentTabCards = computed(function () {
      var _currentTab$value, _currentTab$value$car;
      return ((_currentTab$value = currentTab.value) === null || _currentTab$value === void 0 ? void 0 : (_currentTab$value$car = _currentTab$value[cardsType.value]) === null || _currentTab$value$car === void 0 ? void 0 : _currentTab$value$car.items) || [];
    });
    var otherTabsCards = computed(function () {
      var otherTabs = tabs.value.filter(function (tab) {
        var _tab$sys, _currentTab$sys;
        return (tab === null || tab === void 0 ? void 0 : (_tab$sys = tab.sys) === null || _tab$sys === void 0 ? void 0 : _tab$sys.id) !== (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab$sys = currentTab.sys) === null || _currentTab$sys === void 0 ? void 0 : _currentTab$sys.id);
      });
      var cardIds = new Set();
      var cards = [];
      var _iterator = _createForOfIteratorHelper(otherTabs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _tab$cardsType$value;
          var tab = _step.value;
          var _iterator2 = _createForOfIteratorHelper(tab === null || tab === void 0 ? void 0 : (_tab$cardsType$value = tab[cardsType.value]) === null || _tab$cardsType$value === void 0 ? void 0 : _tab$cardsType$value.items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _card$sys;
              var card = _step2.value;
              if (!cardIds.has(card === null || card === void 0 ? void 0 : (_card$sys = card.sys) === null || _card$sys === void 0 ? void 0 : _card$sys.id) && card !== null && card !== void 0 && card.slug && card !== null && card !== void 0 && card.title && card !== null && card !== void 0 && card.__typename) {
                var _card$sys2;
                cardIds.add(card === null || card === void 0 ? void 0 : (_card$sys2 = card.sys) === null || _card$sys2 === void 0 ? void 0 : _card$sys2.id);
                cards.push(card);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return cards;
    });

    /**
     * Sets the current tab index.
     *
     * @param      {Number}  index   The index
     */
    function setCurrentTabIndex(index) {
      currentTabIndex.value = index;
    }

    /**
     * Gets the internal link for the given card.
     *
     * @param      {Object}  card    The card
     * @return     {String}  The link for card.
     */
    function getLinkForCard(card) {
      var name = '';
      if (props.isAdviceBlock) {
        name = 'page-slug';
      } else if ((card === null || card === void 0 ? void 0 : card.__typename) == 'PageRecipe') {
        name = 'legacy-Recipe-slug';
      }
      return app.localePath({
        name: name,
        params: {
          slug: card === null || card === void 0 ? void 0 : card.slug
        }
      });
    }
    return {
      __sfc: true,
      ProductsCarouselGraphql: ProductsCarouselGraphql,
      ProductsGridGraphql: ProductsGridGraphql,
      props: props,
      app: app,
      $config: $config,
      isMobile: isMobile,
      currentTabIndex: currentTabIndex,
      cardsType: cardsType,
      tabs: tabs,
      currentTab: currentTab,
      currentTabCards: currentTabCards,
      otherTabsCards: otherTabsCards,
      setCurrentTabIndex: setCurrentTabIndex,
      getLinkForCard: getLinkForCard,
      generateTwicPicBackgroundImageSet: generateTwicPicBackgroundImageSet,
      TabsFilter: TabsFilter,
      NuxtLinkCustom: NuxtLinkCustom,
      AzIcon: AzIcon
    };
  }
});